import { render, staticRenderFns } from "./JobFunctionsTable.vue?vue&type=template&id=52ca59ea"
import script from "./JobFunctionsTable.vue?vue&type=script&lang=js"
export * from "./JobFunctionsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../mbp_crm-adminclient-align/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports